<template>
  <section class="pbr-topic-container">
    <section class="pbr-topic-top-img">
      <img alt="" src="static/images/pbr/topic.png">
      <a href="#/pbr/topic/b" style="position: absolute;right: 20px;top:20px;text-decoration: none;">topic b</a>
    </section>
    <section class="pbr-topic-content">
      <div class="pbr-topic-content-container">
        <section class="pbr-topic-project-publish">
          <div class="pbr-topic-title-panel pbr-topic-title-panel-chart">
            <Icon class="pbr-topic-title-panel-radio" type="md-radio-button-on"/>
            <strong>相关项目分布</strong>
          </div>
          <div class="pbr-topic-content">
            <Tabs type="card">
              <TabPane label="区域分布">
                <div class="pbr-topic-content-chart">
                  <div class="pbr-topic-content-desc ">
                    2005-2016年期间，中国银行支持对测试系统国家的总投资额为2047亿美元，总体呈现上升趋势，测试系统的四大区域中，东亚、西亚地区占据了投资的大部分，上升趋势相对更加显著。
                  </div>
                  <div style="flex: 1">
                    <region-dist-chart :data="regionDistChartData"></region-dist-chart>
                  </div>
                </div>
              </TabPane>
              <TabPane label="行业分布">
                <div class="pbr-topic-content-chart">
                  <div class="pbr-topic-content-desc ">
                    中国银行先后与菲律宾、捷克、柬埔寨等多个国家签订了测试系统合作备忘录，大力的支持了测试系统沿线国家项目的开展与投资。
                  </div>
                  <div style="flex: 1">
                    <industry-dist-chart :data="industryDistChatData"></industry-dist-chart>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </section>
        <section class="pbr-topic-project-info">
          <div class="pbr-topic-title-panel pbr-topic-title-panel-chart">
            <Icon class="pbr-topic-title-panel-radio" type="md-radio-button-on"/>
            <strong>项目相关信息</strong>
          </div>
          <div class="pbr-topic-content">
            <Tabs type="card">
              <TabPane label="信息图谱">
                <div class="pbr-topic-content-chart">
                  <div class="pbr-topic-content-desc ">
                    中国银行先后与菲律宾、捷克、柬埔寨等多个国家签订了测试系统合作备忘录，大力的支持了测试系统沿线国家项目的开展与投资。
                  </div>
                  <div style="flex: 1;height: 190px;">
                    <infographic-chart></infographic-chart>
                    <!--                    <atlas-analysis></atlas-analysis>-->
                  </div>
                </div>
              </TabPane>
              <TabPane label="热词分析">
                <div class="pbr-topic-content-chart">
                  <div class="pbr-topic-content-desc ">
                    2005-2016年期间，中国银行支持对测试系统国家的总投资额为2047亿美元，总体呈现上升趋势，测试系统的四大区域中，东亚、西亚地区占据了投资的大部分，上升趋势相对更加显著。
                  </div>
                  <div style="flex: 1;height: 190px;">
                    <hot-word-analysis v-if="hotWordDistChartData.length"
                                       :word-data="hotWordDistChartData"></hot-word-analysis>
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </section>
      </div>
      <div class="pbr-topic-content-container">
        <section class="pbr-topic-project">
          <div class="pbr-topic-title-panel pbr-topic-title-panel-list">
            <Icon class="pbr-topic-title-panel-radio" type="md-radio-button-on"/>
            <strong>相关项目</strong>
          </div>
          <div class="pbr-topic-content">
            <normal-list :data="pbrTopicProject" :page-size="6" goto="pbrProjectDetail"></normal-list>
          </div>
        </section>
        <section class="pbr-topic-info">
          <div class="pbr-topic-title-panel pbr-topic-title-panel-list">
            <Icon class="pbr-topic-title-panel-radio" type="md-radio-button-on"/>
            <strong>相关资讯</strong>
          </div>
          <div class="pbr-topic-content">
            <normal-list :data="pbrTopicInfo" :page-size="6" goto="pbrInfoDetail"></normal-list>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>

<script>
import NormalList from '../index/NormalList'
import TestData from './TestData.js'
import RegionDistChart from './RegionDistChart'
import IndustryDistChart from './IndustryDistChart'
import InfographicChart from './InfographicChart'
// import HotWordAnalysis from './HotWordAnalysis'
import HotWordAnalysis from '../analysis/HotWordAnalysis'
import AtlasAnalysis from '../analysis/AtlasAnalysis'

export default {
  name: 'pbrTopicIndex',
  components: {AtlasAnalysis, NormalList, RegionDistChart, IndustryDistChart, InfographicChart, HotWordAnalysis},
  data () {
    return {
      regionDistChartData: [],
      industryDistChatData: [],
      pbrTopicProject: [],
      pbrTopicInfo: [],
      ...TestData,
      topic: {}
    }
  },
  created () {

  },
  mounted () {
    this.getTopic()
  },
  methods: {
    getTopic () {
      this.$pbrApis.getTopic().then(res => {
        if (res.success) {
          console.log("专题：",res)
          this.topic = res.result
          this.getSpecialProject()
          this.getRegionalDistribution()
          this.getIndustryDistribution()
          this.getTopicNews()
        }
      })
    },
    getSpecialProject () {
      debugger
      this.$pbrApis.getSpecialProject({id: this.topic.id, lang: 'cn'}).then(res => {
        if (res.success) {
          console.log("专题相关项目：",res)
        }
      })
    },
    getRegionalDistribution () {
      this.$pbrApis.getRegionalDistribution({id: this.topic.id, lang: 'cn'}).then(res => {
        if (res.success) {
          console.log("地域分布：",res)
        }
      })
    },
    getIndustryDistribution () {
      this.$pbrApis.getIndustryDistribution({id: this.topic.id, lang: 'cn'}).then(res => {
        if (res.success) {
          console.log("行业分布：",res)
        }
      })
    },
    getTopicNews () {
      this.$pbrApis.getTopicNews({id: this.topic.id}).then(res => {
        if (res.success) {
          console.log("专题新闻：",res)
        }
      })
    }
  },
  watch: {}

}
</script>
<style scoped>
.pbr-topic-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  font-size: 12px;
  line-height: 24px;
}

.pbr-topic-top-img {
  display: flex;
  width: 100%;
  position: relative;
}

.pbr-topic-top-img img {
  flex: 0 0 100%;
}

.pbr-topic-content-container {
  display: flex;
  width: 100%;
  margin: 20px 0;
  justify-content: space-evenly;
}

.pbr-topic-content {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 20px;
}

.pbr-topic-content-desc {
  text-indent: 2em;
  width: 250px;
  display: flex;
  align-items: center;
}

.pbr-topic-content-chart {
  display: flex;
  padding: 0 20px;
}

.pbr-topic-project-publish, .pbr-topic-project-info, .pbr-topic-project, .pbr-topic-info {
  width: 40%;
  height: 250px;
}

.pbr-topic-project-publish {

}

.pbr-topic-project-info {

}

.pbr-topic-project {

}

.pbr-topic-info {

}

.pbr-topic-title-panel {
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
}

.pbr-topic-title-panel strong {
  font-size: 16px;
  color: #fff;
  margin: 0 10px;
}

.pbr-topic-title-panel-chart {
  background-color: #E83B56;
}

.pbr-topic-title-panel-list {
  background-color: #008BCE;
}

.pbr-topic-title-panel-radio {
  color: #fff; /* ff3355 008bce*/
  margin-left: 8px;
  font-size: 18px;
}

</style>
